import type { ComponentChildren, CSSProperties } from 'preact'

import {
  bodyTextStyle,
  captionStyle,
  paragraphStyle,
} from '#src/assets/ui/shared/styles.ts'

type ParagraphVariant = 'default' | 'body' | 'caption'

const variantStyles: Record<ParagraphVariant, CSSProperties> = {
  default: paragraphStyle,
  body: { display: 'block', marginBottom: '1rem', ...bodyTextStyle },
  caption: { display: 'block', margin: 0, ...captionStyle },
}

export function Paragraph({
  variant = 'default',
  style,
  className,
  children,
}: {
  variant?: ParagraphVariant
  style?: CSSProperties
  className?: string
  children: ComponentChildren
}) {
  return (
    <p className={className} style={{ ...variantStyles[variant], ...style }}>
      {children}
    </p>
  )
}
